import { ErrorCode } from '@afterpaytouch/portal-api/types'

export const getUsername = (isMobileLogin: boolean, mobile?: string, email?: string): string => {
  if (isMobileLogin) {
    return mobile ?? ''
  }
  return email ?? ''
}

export const LOGIN_PASSWORD_ERROR_MESSAGES = {
  EmptyPassword: 'password:error:emptyPassword',
  Auth: 'password:error.auth',
  AuthMaxAttempt: 'password:error.authMaxAttempt',
  AuthMaxAttemptApplePaylater: 'password:error.authMaxAttempt_applepaylater',
  AccountDisabled: 'password:error.accountDisabled',
  Locked: 'password:error.locked',
  PaywatchCheckFailed: 'password:error.paywatchCheckFailed',
  AccountLocked: 'password:error.accountLocked',
  Unknown: 'password:error.unknown',
} as const

export type LoginPasswordErrorMessage = (typeof LOGIN_PASSWORD_ERROR_MESSAGES)[keyof typeof LOGIN_PASSWORD_ERROR_MESSAGES]

export const getLoginPasswordErrorMessage = (errorCode: ErrorCode, isApplePaylaterFlow: boolean): LoginPasswordErrorMessage => {
  switch (errorCode) {
    case ErrorCode.AuthenticationFailure:
      return LOGIN_PASSWORD_ERROR_MESSAGES.Auth
    case ErrorCode.AuthenticationFailureMaxAttempts:
      return isApplePaylaterFlow ? LOGIN_PASSWORD_ERROR_MESSAGES.AuthMaxAttemptApplePaylater : LOGIN_PASSWORD_ERROR_MESSAGES.AuthMaxAttempt
    case ErrorCode.AccountDisabled:
      return LOGIN_PASSWORD_ERROR_MESSAGES.AccountDisabled
    case ErrorCode.AccountClosed:
    case ErrorCode.AccountSuspended:
      return LOGIN_PASSWORD_ERROR_MESSAGES.Locked
    case ErrorCode.PaywatchCheckFailed:
      return LOGIN_PASSWORD_ERROR_MESSAGES.PaywatchCheckFailed
    case ErrorCode.AccountLocked:
      return LOGIN_PASSWORD_ERROR_MESSAGES.AccountLocked
    default:
      return LOGIN_PASSWORD_ERROR_MESSAGES.Unknown
  }
}
